import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  ControlContainer,
  FormBuilder,
  FormGroup,
  FormGroupDirective,
  Validators,
} from '@angular/forms';
import { filter, Observable } from 'rxjs';
import {
  ContractModel,
  CreateContractFormModel,
} from '../../../../../../shared/store/contract/types';
import { Entity } from 'src/app/shared/store/view/types';
import { ContractService } from '../../../../../../shared/store/contract/contract.service';
import { take } from 'rxjs/operators';
import { formatDate } from '../../../../../../shared/helper/datehelper';
import { ReferralCampaign } from '../../../../../../shared/store/campaign/types';
import {
  removeValidators,
  setValidators,
} from '../../../../../../shared/helper/formhelper';

@Component({
    selector: 'app-contract-form-marketing',
    templateUrl: './contract-form-marketing.component.html',
    styleUrls: ['./contract-form-marketing.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective,
        },
    ],
    standalone: false
})
export class ContractFormMarketingComponent implements OnInit {
  createContractFormModel$: Observable<ContractModel>;
  contractDetail$: Observable<ContractModel>;
  form: FormGroup;
  isCampaignReferral: boolean = false;
  protected readonly Entity = Entity;

  constructor(
    private readonly contractService: ContractService,
    private parent: FormGroupDirective,
    private formBuilder: FormBuilder,
  ) {
    this.createContractFormModel$ =
      this.contractService.getContractModel.value$;
    this.contractDetail$ = this.contractService.getByUniqueId.value$;
  }

  ngOnInit(): void {
    this.form = this.parent.form;
    this.form.addControl(
      'marketingFormGroup',
      this.formBuilder.group({
        marketingCampaignId: [undefined, [Validators.required]],
        marketingMediumId: [undefined],
        marketingSourceId: [undefined],
        marketingCreationDate: [''],
        marketingReferrerId: [undefined],
      }),
    );

    this.createContractFormModel$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          marketingFormGroup: {
            marketingSourceId: x.sourceId,
            marketingCampaignId: x.campaignId,
            marketingMediumId: x.mediumId,
          },
        });
      });

    this.contractDetail$
      .pipe(
        filter((x) => !!x),
        take(1),
      )
      .subscribe((x) => {
        this.form.patchValue({
          marketingFormGroup: {
            marketingCampaignId: x.campaignId,
            marketingMediumId: x.mediumId,
            marketingSourceId: x.sourceId,
            marketingCreationDate: formatDate(
              x.creationDate,
              'ToInverseSqlDate',
            ),
            marketingReferrerId: x.contactReferrerId,
          },
        });
      });

    this.form.controls['marketingFormGroup']
      .get('marketingCampaignId')
      ?.valueChanges.subscribe((x) => {
        if (x == ReferralCampaign) {
          this.isCampaignReferral = true;

          setValidators(
            this.form.controls['marketingFormGroup'].get('marketingReferrerId'),
            Validators.required,
          );
        } else {
          this.isCampaignReferral = false;

          removeValidators(
            this.form.controls['marketingFormGroup'].get('marketingReferrerId'),
            Validators.required,
          );
        }
      });
  }
}
